import moment from 'moment';
export default {
  getArea: function (number) {
    return String(number).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  getDate: function (data) {
    console.log('getDate filter executing with:', data); // 调试日志
    if (!data) return '';

    // 尝试解析多种格式，优先尝试匹配度高的格式
    const date = moment(data, [
      'YYYY-MM-DD HH:mm:ss',  // 您的数据格式
      'DD-MM-YYYY HH:mm:ss',
      'YYYY-MM-DD',
      'DD-MM-YYYY'
    ], true); // 启用严格模式

    if (date.isValid()) {
      console.log('Date parsed successfully:', date.format());

      // 检查原始值是否包含时分秒信息
      const hasTime = String(data).includes(':') || String(data).length > 10;

      if (hasTime) {
        // 有时间部分，显示为 "Nov 17,2025 12:00:00" 格式
        const formatted = date.format('MMM D,YYYY HH:mm:ss');
        console.log('Formatted with time:', formatted);
        return formatted;
      } else {
        // 只有日期，显示为 "Nov 17,2025" 格式
        const formatted = date.format('MMM D,YYYY');
        console.log('Formatted date only:', formatted);
        return formatted;
      }
    } else {
      console.error('Invalid date format:', data);
      return data; // 返回原始数据而不是null
    }
  },
  convertAndFormatDate: function (dateString) {
    const date = moment(dateString, 'DD/MM/YYYY');
    console.log(dateString, date, '2222222222222');
    if (date.isValid()) {
      const jsDate = date.toDate();
      const options = { year: "numeric", month: "short", day: "numeric" };
      const currentDate = jsDate.toLocaleDateString("en-US", options);
      return currentDate;
    } else {
      console.error('Invalid date format:', dateString);
      return null;
    }
  },
  getMatchedClientAdjustToken: function (adjName) {
    try {
      const clientAdjustTokens = JSON.parse(
        localStorage.getItem("clientAdjustToken")
      );
      return clientAdjustTokens?.find(token => token.eventName === adjName);
    } catch (e) {
      console.error('Error parsing clientAdjustToken:', e);
      return null;
    }
  },
  processClientAdjustTokens(eventNames) {
    return Promise.all(
      eventNames.map(name => {
        const matchedToken = this.getMatchedClientAdjustToken(name);
        if (matchedToken) {
          console.log("Matched eventToken:", matchedToken.eventToken);
          return nativeBridgeConfig.nativeCall(
            localStorage.getItem("appCode") + "-3",
            matchedToken.eventToken
          );
        }
        return Promise.resolve();
      })
    );
  },

  timeTracker: (function () {
    const timers = {};

    return function (key) {
      if (!timers[key]) {
        timers[key] = {
          startTime: Date.now(),
          isRunning: true
        };
      } else if (timers[key].isRunning) {
        const elapsed = (Date.now() - timers[key].startTime) / 1000;
        timers[key].isRunning = false;
        return Math.floor(elapsed * 1);
      } else {
        timers[key].startTime = Date.now();
        timers[key].isRunning = true;
      }
    };
  })()
};

